// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","active":"Navbar_active__l7FQP","initials":"Navbar_initials__sJKcK","toggler":"Navbar_toggler__Rs4T4"};